import React, { useCallback, useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogTitle, Tooltip } from '@mui/material';

import { useAppDispatch, useAppSelector } from 'hooks/store';

import { ThunkGetCompanyPolicies } from 'store/verificationSettings/thunks';
import { ConfigurationSelector, setBannerState } from 'store/configuration';
import { PodDataSelector } from 'store/pod';

import { ReactComponent as PolicyIcon } from 'assets/icons/policy.svg';

import Button from 'components/Button';
import { isAlphaPopupWindow } from 'components/Alpha/alphaVoicePopup';
import { Integrations } from 'constants/integrations';

interface ICompanyPolicy {
  enableVerificationBanner: boolean;
  showVerificationBannerOnMount: boolean;
  verificationBannerText: string;
}

const CompanyPolicies: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [companyPolicies, setCompanyPolicies] = useState<ICompanyPolicy | undefined>(undefined);

  const dispatch = useAppDispatch();
  const config = useAppSelector(ConfigurationSelector);
  const podData = useAppSelector(PodDataSelector);

  const closePolicyDialog = (): void => {
    dispatch(setBannerState(false));
  };

  const onMount = useCallback(() => {
    setLoading(true);
    if (config?.psaId && podData?.CompanyId && config.psa !== Integrations.SuperOps) {
      dispatch(
        ThunkGetCompanyPolicies({
          psaId: config?.psaId,
          companyId: podData?.CompanyId,
        }),
      )
        .unwrap()
        .then(res => {
          setCompanyPolicies(res);

          if (
            res.showVerificationBannerOnMount &&
            res.enableVerificationBanner &&
            !isAlphaPopupWindow()
          ) {
            dispatch(setBannerState(true));
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [config?.psaId, podData?.CompanyId]);

  useEffect(() => {
    onMount();
  }, [onMount]);

  if (loading) return <></>;
  return (
    <>
      <Tooltip title="Company Policies">
        <PolicyIcon
          onClick={() => {
            dispatch(setBannerState(true));
          }}
        />
      </Tooltip>

      {config?.openBanner && companyPolicies?.enableVerificationBanner && (
        <Dialog
          open={config?.openBanner}
          onClose={closePolicyDialog}
          disableAutoFocus
          disableEnforceFocus
          disableRestoreFocus
        >
          <DialogTitle>Company Policies</DialogTitle>
          <DialogContent>
            {companyPolicies?.verificationBannerText}
            <div style={{ margin: '10px 0px', display: 'flex', justifyContent: 'flex-end' }}>
              <Button label="Close" onClick={closePolicyDialog} />
            </div>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default CompanyPolicies;
